module.exports = __webpack_public_path__ + "static/RST-Steckerset-2p-e53166d99917670cde5fc301b4039c28.jpg";